import { render, staticRenderFns } from "./Empty.vue?vue&type=template&id=f2333620&"
import script from "./Empty.vue?vue&type=script&lang=ts&"
export * from "./Empty.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports